export const FOLLOWUP_TYPE_LIST = [
  "CPAP Follow-Up 1M",
  "CPAP Follow-Up 3M",
  "CPAP Follow-Up 6M",
  "CPAP Follow-Up 1Y",
];

export const LPH_FOLLOWUP_TYPE_LIST = [
  "CPAP Follow-Up 1M",
  "CPAP Follow-Up 6M",
  "CPAP Follow-Up 1Y",
];

const isLphIdentifier = (value) => /\bLPH\b/i.test(String(value || ""));

export const isLphNode = (nodeName, nodeList = []) => {
  const selectedNode = (nodeList || []).find(
    (node) => node && node.nodename === nodeName,
  );

  return [
    nodeName,
    selectedNode && selectedNode.nodename,
    selectedNode && selectedNode.nodecode,
  ].some(isLphIdentifier);
};

export const getFollowupTypeOptionsForNode = (nodeName, nodeList = []) =>
  isLphNode(nodeName, nodeList)
    ? LPH_FOLLOWUP_TYPE_LIST
    : FOLLOWUP_TYPE_LIST;

export const isFollowupTypeAllowedForNode = (
  type,
  nodeName,
  nodeList = [],
) => getFollowupTypeOptionsForNode(nodeName, nodeList).includes(type);

export const getNextFollowupTypeForContinueTherapy = (
  currentType,
  nodeName,
  nodeList = [],
) => {
  if (currentType === "CPAP Follow-Up 1M") {
    return isLphNode(nodeName, nodeList)
      ? "CPAP Follow-Up 6M"
      : "CPAP Follow-Up 3M";
  }

  if (currentType === "CPAP Follow-Up 3M") return "CPAP Follow-Up 6M";
  if (currentType === "CPAP Follow-Up 6M") return "CPAP Follow-Up 1Y";
  if (currentType === "CPAP Follow-Up 1Y") return "CPAP Follow-Up 1Y";

  return currentType || "CPAP Follow-Up 1M";
};
